import { usePatientParamContext } from "@/modules/patients/stores/PatientParamProvider"

const useCountryParam = () => {
  const { country } = usePatientParamContext()
  return country
}

export { useCountryParam }
